<template>
  <table class="min-w-full border-separate border-spacing-0">
    <thead>
      <tr>
        <th scope="col" class="sticky top-0 z-10 border-b border-l border-gray-300 bg-gray-100 py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900">ID</th>
        <th scope="col" class="sticky top-0 z-10 border-b border-l border-gray-300 bg-gray-100 px-4 py-3.5 text-left text-sm font-semibold text-gray-900">Category</th>
        <th scope="col" class="sticky top-0 z-10 border-b border-l border-gray-300 bg-gray-100 px-4 py-3.5 text-left text-sm font-semibold text-gray-900">Mark</th>
        <th scope="col" class="sticky top-0 z-10 border-b border-l border-gray-300 bg-gray-100 py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900">Description</th>
        <th scope="col" class="sticky top-0 z-10 border-b border-l border-gray-300 bg-gray-100 py-3.5 pl-4 pr-4" />
      </tr>
    </thead>
    <tbody class="bg-white">
      <tr v-for="item in items" :key="item.id" class="divide-x divide-gray-200 cursor-pointer even:bg-gray-50 hover:bg-primary-100/60" @click="emit('click', item)">
        <td class="border-b border-gray-200 whitespace-nowrap py-2 pl-4 pr-4 text-sm font-medium text-gray-900">
          <div class="max-w-[58px] truncate font-mono text-xs">
            {{ item.id }}
          </div>
        </td>
        <td class="border-b border-gray-200 whitespace-nowrap py-2 px-4 text-sm text-gray-500">{{ item.category }}</td>
        <td class="border-b border-gray-200 whitespace-nowrap py-2 px-4 text-sm text-gray-500">{{ findParameterValue(item, 'ALL_MODEL_MARK') }}</td>
        <td class="border-b border-gray-200 py-2 pl-4 pr-4 text-sm text-gray-500">{{ findParameterValue(item, 'ALL_MODEL_DESCRIPTION') }}</td>
        <td class="border-b border-gray-200 p-0 w-10 text-center">
          <button class="w-full h-full flex justify-center items-center text-primary-600 hover:text-primary-400" @click.stop="emit('info', item)">
            <MagnifyScan class="h-6 w-6" />
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import MagnifyScan from 'vue-material-design-icons/MagnifyScan.vue';

defineProps({
  items: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits([ 'click', 'info' ]);

function findParameterValue(info, parameterName) {
  const parameters = info?.properties?.Parameters;
  if (!parameters) {
    return null;
  }

  for (const group of Object.values(parameters)) {
    for (const parameter of Object.values(group || {})) {
      if (parameter?.internalDefinitionName === parameterName || parameter?.name === parameterName) {
        return parameter.value;
      }
    }
  }

  return null;
}

/*
{
  "id": "b69bcb71c6ba602a6f13f014b291cc17",
  "category": "Doors",
  "parameters": {
    "ALL_MODEL_MARK": {
      "value": "B4FM01-DORT1-102-01"
    },
    "ALL_MODEL_DESCRIPTION": {
      "value": "Door DORT1 - Curtain Wall Dbl Glass_Door DORT1"
    },
    "ALL_MODEL_URL": {
      "value": null
    },
    "ALL_MODEL_MANUFACTURER": {
      "value": null
    }
  }
}
*/
</script>
